import React, { useState, useEffect } from "react";
import { SERVER_URL, ACCESS_TOKEN, USE_OVERLAY } from "../config/config.js";
import Navbar from "./Navbar";
import Titlebar from "./Titlebar";
import "./EwbExpiringToday.css";
import ReportTable from "./ReportTable";
import Card from "./Card";
import Background from "./Background.js";
import { excelReport } from "../utils/ExcelReport.js";
// import LoadingOverlay from "react-loading-overlay";


const EwbManuallyStopped = ({ sessionObject }) => {
  const [overlay, setOverlay] = useState(false);
  const [checkedList, setCheckedList] = React.useState([]);
  const [cewbCheckedList, setCewbCheckedList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const [data, setData] = React.useState([]);
  const fetchIdRef = React.useRef(0);
  const [autoExtension, setAutoExtension] = useState();
  const [reportMode, setReportMode] = useState("normal");
  const [pendingPartBData, setPendingPartBData] = useState([]);

  var ACCESS_TOKEN = null;

  let date = new Date();
  let dateMDY =
    `${date.getFullYear()}-${
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1
    }-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}` +
    " 23:59:00";
  let dateDMY = `${
    date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
  }-${
    date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
  }-${date.getFullYear()}`;
  let dateMDY2 = `${date.getFullYear()}-${
    date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
  }-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`;
  let dateDMY2 = `${
    date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
  }-${
    date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
  }-${date.getFullYear()}`;

  const formatDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d)) return "";

    let day = String(d.getDate()).padStart(2, "0");
    let month = String(d.getMonth() + 1).padStart(2, "0");
    let year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };


  const fetchData = React.useCallback(
    async ({ pageSize, pageIndex, sortBy, customFilters }) => {
      // This will get called when the table needs new data
      // You could fetch your data from literally anywhere,
      // even a server. But for this example, we'll just fake it.

      // Give this fetch an ID
      const fetchId = ++fetchIdRef.current;
      // console.log("12323", sortBy, customFilters, fetchId);
      // Set the loading state
      setLoading(true);

      let report_type = sessionStorage.getItem("report_type");
      if (report_type == "expiring_today") {
        customFilters.valid_upto = dateDMY;
      }
      if (report_type == "extended_today") {
        customFilters.last_extended = dateDMY2;
      }
      if (report_type == "manually_stopped") {
        customFilters.manually_stopped = "1";
      }
      if (report_type == "expied_last_week") {
        customFilters.expired_last_week = true;
      }
      if (report_type == "godown_extension") {
        customFilters.godown_extension = 1;
      }
      if (report_type == "all") {
      }

      if (fetchId === fetchIdRef.current) {
        ACCESS_TOKEN = "Bearer " + sessionStorage.getItem("login");
        var response = await fetch(SERVER_URL + "/eway/db/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: ACCESS_TOKEN,
          },
          body: JSON.stringify({
            paginate: {
              number_of_rows: pageSize,
              page_number: pageIndex + 1,
            },
            sort_fields: sortBy,
            filter_fields: customFilters,
          }),
        });
        let temp_data = await response.json();
        if (!("data" in temp_data)) {
          setLoading(false);
          return;
        }
        setData(temp_data.data);
        setPageCount(Math.ceil(temp_data["total_rows"] / pageSize));
      }
      setLoading(false);
    },
    []
  );

  const fetchPendingPartB = React.useCallback(
    async ({ pageSize = 100, pageIndex = 0 } = {}) => {
      try {
        if (!autoExtension || !autoExtension.company_id) {
          return;
        }

        setLoading(true);
        ACCESS_TOKEN = "Bearer " + sessionStorage.getItem("login");

        const companyId = autoExtension.company_id;

        const res = await fetch(
          SERVER_URL + `/eway/company/${companyId}/active_ewaybills`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: ACCESS_TOKEN,
            },
            body: JSON.stringify({
              number_of_rows: pageSize,
              page_number: pageIndex + 1,
            }),
          }
        );

        const json = await res.json();
        setPendingPartBData(json.data || []);

        if (typeof json.count === "number") {
          setPageCount(Math.ceil(json.count / pageSize));
        } else {
          setPageCount(1);
        }
      } catch (err) {
        console.log("Error fetching Pending Part B:", err);
      } finally {
        setLoading(false);
      }
    },
    [autoExtension]
  );

  useEffect(() => {
    if (reportMode === "pending_part_b") {
      fetchPendingPartB({ pageSize: 100, pageIndex: 0 });
    }
  }, [reportMode]);

  const handleCheckboxChange = (row) => {
    const val = row[0].value;
    const cewbval = row[0].row.values.cewb_no;
    const ind = checkedList.indexOf(val);
    let tempChecked = [...checkedList];
    let cewbtempChecked = [...cewbCheckedList];
    if (ind > -1) {
      tempChecked.splice(ind, 1);
      cewbtempChecked.splice(ind, 1);
    } else {
      tempChecked.push(val);
      cewbtempChecked.push(cewbval);
    }
    setCheckedList(tempChecked);
    setCewbCheckedList(cewbtempChecked);
  };

  const getSelectAllValue = () => {
    const isAllSelected = checkedList.length == data.length;
    return isAllSelected;
  };

  const isChecked = (row) => {
    const val = row[0].value;
    return checkedList.indexOf(val) > -1;
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Number",
        accessor: "ewaybill_no",
        width: "120px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "Date",
        accessor: "ewb_date",
        width: "120px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "Valid Upto",
        accessor: "valid_upto",
        width: "120px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "Last Extended",
        accessor: "last_extended",
        width: "130px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "Extended Times",
        accessor: "extended_times",
        width: "120px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "Amount",
        accessor: "amount",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "From",
        accessor: "consignor_place",
        width: "150px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "To",
        accessor: "consignee_place",
        width: "150px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "Consignor",
        accessor: "consignor_name",
        width: "250px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "Consignee",
        accessor: "consignee_name",
        width: "250px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "CEWB",
        accessor: "cewb_no",
        width: "120px",
        minWidth: "10px",
        canFilter: true,
      },

      {
        Header: "Truck No",
        accessor: "truck_number",
        width: "150px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Godown Extension?",
        accessor: "godown_extension",
        //text: "Expired Last Week",
        width: "150px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Stopped?",
        accessor: "manually_stopped",
        //text: "Expired Last Week",
        width: "120px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Status",
        accessor: (row) => {
          if (row.is_expired === true) {
            return "Expired";
          } else if (row.manually_stopped === 1) {
            return "Manually Stopped";
          } else {
            return row.ewaybill_status;
          }
        },
        //text: "Expired Last Week",
        width: "120px",
        minWidth: "10px",
        canFilter: true,
      },
    ],
    []
  );

  const pendingPartBColumns = React.useMemo(
    () => [
      {
        Header: "Number",
        accessor: "ewaybill_no",
        width: "100px",
        minWidth: "120px"
      },

      {
        Header: "Date",
        accessor: (row) => formatDate(row.ewb_date),
        width: "120px",
        minWidth: "100px"
      },

      {
        Header: "Valid Upto",
        accessor: (row) => formatDate(row.valid_upto),
        width: "120px",
        minWidth: "100px"
      },

      {
        Header: "Last Extended",
        accessor: (row) => formatDate(row.last_extended),
        width: "120px",
        minWidth: "120px"
      },

      {
        Header: "Extended Times",
        accessor: "extended_times",
        width: "120px",
        minWidth: "110px"
      },

      {
        Header: "Amount",
        accessor: "amount",
        width: "120px",
        minWidth: "100px"
      },

      {
        Header: "From",
        accessor: "consignor_place",
        width: "150px",
        minWidth: "150px"
      },

      {
        Header: "To",
        accessor: "consignee_place",
        width: "150px",
        minWidth: "150px"
      },

      {
        Header: "Consignor",
        accessor: "consignor_name",
        width: "180px",
        minWidth: "180px"
      },

      {
        Header: "Consignee",
        accessor: "consignee_name",
        width: "180px",
        minWidth: "180px"
      },

      {
        Header: "CEWB",
        accessor: "cewb_no",
        width: "120px",
        minWidth: "120px"
      },

      {
        Header: "Truck No",
        accessor: "truck_number",
        width: "140px",
        minWidth: "120px"
      },

      {
        Header: "Godown Extension?",
        accessor: "godown_extension",
        width: "150px",
        minWidth: "120px"
      },

      {
        Header: "Stopped?",
        accessor: "manually_stopped",
        width: "120px",
        minWidth: "100px"
      },

      {
        Header: "Status",
        accessor: (row) => {
          if (row.is_expired) return "Expired";
          if (row.manually_stopped === 1) return "Manually Stopped";
          return row.ewaybill_status;
        },
        width: "120px",
        minWidth: "100px"
      }
    ],
    []
  );

  const reportConfig = {
    expiring_today: {
      file: "Ewb-Expiring-Today.xlsx",
      title: "E-Way Bills Expiring Today"
    },
    extended_today: {
      file: "Ewb-Extended-Today.xlsx",
      title: "E-Way Bills Extended Today"
    },
    manually_stopped: {
      file: "Ewb-Manually-Stopped.xlsx",
      title: "E-Way Bills Manually Stopped"
    },
    expied_last_week: {
      file: "Ewb-Expired-Last-Week.xlsx",
      title: "E-Way Bills Expired Last Week"
    },
    all: {
      file: "All-Ewb-Report.xlsx",
      title: "All E-Way Bills Report"
    },
    godown_extension: {
      file: "Godown-Extension-Report.xlsx",
      title: "Godown Extension Report"
    }
  };

  const handleSelectAll = () => {
    let tempChecked = [];
    data.forEach((row) => {
      tempChecked.push(row.ewaybill_no);
    });
    setCheckedList(tempChecked);
  };

  const handleDeselectAll = () => {
    setCheckedList([]);
  };

  const start = async (e) => {
    ACCESS_TOKEN = "Bearer " + sessionStorage.getItem("login");
    setOverlay(true);
    const rs = await fetch(SERVER_URL + "/eway/eway_bill_start", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: ACCESS_TOKEN,
      },
      body: JSON.stringify({ data: checkedList }),
    });
    const data = await rs.json();
    // fetchData()
    setOverlay(false);
    window.location.reload();
  };

  const stop = async (e) => {
    ACCESS_TOKEN = "Bearer " + sessionStorage.getItem("login");
    setOverlay(true);
    const rs = await fetch(SERVER_URL + "/eway/eway_bill_stop", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: ACCESS_TOKEN,
      },
      body: JSON.stringify({ data: checkedList }),
    });
    const data = await rs.json();
    setOverlay(false);
    window.location.reload();
  };

  const godownIn = async (e) => {
    ACCESS_TOKEN = "Bearer " + sessionStorage.getItem("login");
    setOverlay(true);
    const rs = await fetch(SERVER_URL + "/eway/godown_start/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: ACCESS_TOKEN,
      },
      body: JSON.stringify({ data: checkedList }),
    });
    const data = await rs.json();
    // fetchData()
    setOverlay(false);
    window.location.reload();
  };

  const godownOut = async (e) => {
    ACCESS_TOKEN = "Bearer " + sessionStorage.getItem("login");
    setOverlay(true);
    const rs = await fetch(SERVER_URL + "/eway/godown_stop/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: ACCESS_TOKEN,
      },
      body: JSON.stringify({ data: checkedList }),
    });
    const data = await rs.json();
    // fetchData()
    setOverlay(false);
    window.location.reload();
  };

  const getButtons = () => {
    let report_type = sessionStorage.getItem("report_type");
    if (report_type == "expiring_today") {
      return (
        <div className="flex">
          <button className="btn" onClick={stop}>
            Stop
          </button>
          <button className="btn" onClick={godownIn}>
            Godown In
          </button>
        </div>
      );
    }
    if (report_type == "extended_today") {
      return (
        <button className="btn" onClick={stop}>
          Stop
        </button>
      );
    }
    if (report_type == "manually_stopped") {
      return (
        <button className="btn" onClick={start}>
          Start
        </button>
      );
    }
    if (report_type == "expied_last_week") {
      return <></>;
    }
    if (report_type == "all") {
      return (
        <div>
          <button className="btn" onClick={start}>
            Start
          </button>
          <button className="btn" onClick={stop}>
            Stop
          </button>
          <button className="btn" onClick={godownIn}>
            Godown In
          </button>
          <button className="btn" onClick={godownOut}>
            Godown Out
          </button>
        </div>
      );
    }

    if (report_type == "godown_extension") {
      return (
        <button className="btn" onClick={godownOut}>
          Godown Out
        </button>
      );
    }
  };

  return (
    <div className="ewb-expiring-today">
      <Background />

      <Titlebar
        sessionObject={sessionObject}
        checkedList={checkedList}
        cewbCheckedList={cewbCheckedList}
        autoExtension={autoExtension}
        setAutoExtension={setAutoExtension}
        reportMode={reportMode}  
        setReportMode={setReportMode}
      />

      <div className="inner">
        <Card />

        {/*Show Pending Part B report exclusively when selected; else show original UI. Nothing removed below. */}
        {reportMode === "pending_part_b" ? (
          <>
            <div className="align-btns">
              <div className="align-btn">
                <h2>Pending Part B Report</h2>
              </div>
              <div>
                <button
                  className="btn"
                  onClick={() => setReportMode("normal")}
                >
                  Back
                </button>
              </div>
            </div>
            <div className="wrapper">
              <ReportTable
                key={reportMode} 
                checkbox={false}
                columns={pendingPartBColumns}
                data={pendingPartBData}
                fetchData={fetchPendingPartB}
                loading={loading}
                pageCount={pageCount}
                title="PendingPartBReport"
              />
            </div>
            <div className="xls-download-wrapper">
              <button
                className="download-xls-btn"
                disabled={!pendingPartBData || pendingPartBData.length === 0}
                style={{ opacity: (!pendingPartBData || pendingPartBData.length === 0) ? 0.5 : 1 }}
                onClick={() =>
                  excelReport(
                    pendingPartBColumns,
                    pendingPartBData,
                    "Pending-Part-B-Report.xlsx",
                    "Pending Part B Report"
                  )
                }
              >
                Download as XLS
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="align-btns">
              <div className="align-btn">{getButtons()}</div>
              <div className="align-counts">
                <div className="align-count">
                  <span>Allowed EWB Count</span> &nbsp;
                  <span>{autoExtension && autoExtension.allowed_ewb_count}</span>
                </div>
                <div className="align-count">
                  <span>Current EWB Count</span> &nbsp;
                  <span>{autoExtension && autoExtension.current_ewb_count}</span>
                </div>
              </div>
            </div>
            <div className="wrapper">
              <ReportTable
                key={reportMode} 
                checkbox={true}
                handleCheckboxChange={handleCheckboxChange}
                checkedList={checkedList}
                columns={columns}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                isChecked={isChecked}
                getSelectAllValue={getSelectAllValue}
                handleSelectAll={handleSelectAll}
                handleDeselectAll={handleDeselectAll}
                title="EwbExtensionReport"
              />
            </div>

            <div className="xls-download-wrapper">
              <button
                className="download-xls-btn"
                disabled={!data || data.length === 0}
                style={{ opacity: (!data || data.length === 0) ? 0.5 : 1 }}
                onClick={() =>
                  excelReport(
                    columns,
                    data,
                    reportConfig[sessionStorage.getItem("report_type")].file,
                    reportConfig[sessionStorage.getItem("report_type")].title
                  )
                }
              >
                Download as XLS
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EwbManuallyStopped;
